export default "__VITE_ASSET__C2bTULL$__"